import { AxiosError } from 'axios'
import { action, flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'

import { UrlParams } from 'Portals/Customer/constants'
import { Mou } from 'Portals/Customer/entities'
import {
	getFiltersConfig,
	getSearchConfig
} from 'Portals/Customer/Pages/Mou/TableList/Filters/utils/config'
import { MouRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_MOU_PAGE_SIZE = 'is2/mouPageSize'

export class MouTable extends TableStore<Mou.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_MOU_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: MouRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@action.bound
	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.subject, UrlParams.mouNumber, CoreUrlParams.searchQuery]
		const filterKeys = [
			UrlParams.serviceSiteId,
			UrlParams.issuedDateFrom,
			UrlParams.issuedDateTo
		]

		const mergedSearchConfig = {
			...getSearchConfig(),
			...searchQueryConfig
		}
		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFiltersConfig())
	}

	reset = () => {
		this.resetTable()
	}
}
